import HeadingMain from "../../components/Heading";
import CommonAccordian from "../../components/CommonAccordian";
import './index.scss';
import { faqArray } from './FAQList';

const FAQ = () => {

  return (
    <section className="mainContent">
      <div className="faqSection">
        <HeadingMain text="Frequently asked questions" style={{textAlign: 'center'}} />
        <CommonAccordian array={faqArray}/>
        <div className="viewAllLink">
          <a href="https://docs.cleartax.in/gst-pay-later-support-and-faqs/" target="_blank">View All</a>
        </div>
      </div>
    </section>
  )
}

export default FAQ;